import { Skeleton } from '@/components/atoms/skeleton';
import { cn } from '@/lib/utils';

interface DataTableSkeletonRowsProps {
  rowCount: number;
  columnCount: number;
  actionCellClassName?: string;
}

export function DataTableSkeletonRows({
  rowCount,
  columnCount,
  actionCellClassName = 'w-16 border-b border-border/40 pr-4',
}: DataTableSkeletonRowsProps) {
  return Array.from({ length: rowCount }).map((_, rowIndex) => (
    <tr key={rowIndex}>
      {Array.from({ length: columnCount }).map((__, cellIndex) => (
        <td
          key={cellIndex}
          className={cn('border-b border-border/40 py-2.5', cellIndex === 0 ? 'pl-4 pr-3' : 'px-3')}
        >
          <Skeleton className="h-3.5 w-full rounded" />
        </td>
      ))}
      <td className={actionCellClassName} />
    </tr>
  ));
}
